import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class PagoService {

  constructor(private httpService: HttpService) { }

  getPagosByUser() {
    return this.httpService.get('usuario/pagos');
  }
  pagarPedidos(request) {
    return this.httpService.post('pedido/pagar', request);
  }
  getPagosAllUsers(data = null){
    let url = "pedido/deuda";
    if (data){
      url = "pedido/deuda?precio="+data.value
    }
    return this.httpService.get(url);
  }

  getHistorialPagos(fecha) {
    return this.httpService.get('usuario/admPagos?fecha=' + fecha);
  }
}
